import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { Field } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import AutosuggestField from 'components/fields/AutosuggestField';
import Tooltip from 'components/common/Tooltip';

import { requestSearchUsers } from 'redux/modules/users';

import * as validate from 'utils/validate';

const styles = theme => ({
  root: {
    marginTop: 10,
  },
  tooltipAssignedBy: {
    maxWidth: 70,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    marginRight: 3,
    color: theme.palette.primary[600],
    fontWeight: 500,
    cursor: 'pointer',
    verticalAlign: 'bottom',
    '&:hover, &:focus': {
      textDecoration: 'underline',
      textShadow: '.4px 0 0 currentColor, -.4px 0 0  currentColor',
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 100,
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: 150,
    },
  },
});

const ProductClaimAssignedUserFields = ({
  name, onFieldFocus, onFieldBlur, classes, disabled, ...fields
}) => {
  const assignedUserID = get(fields, `${name}.assignedUserID`);
  const assignedFromUserFirstName = get(fields, `${name}.assignedFromUserFirstName`);
  const assignedFromUserLastName = get(fields, `${name}.assignedFromUserLastName`);
  return (
    <Field
      id={`${name}.assignedUserName`}
      name={`${name}.assignedUserName`}
      label={(
        <Fragment>
          <Tooltip
            className={classes.tooltipAssignedBy}
            content={
              <Typography>
                {`${assignedFromUserFirstName.input.value} ${assignedFromUserLastName.input.value}`}
              </Typography>
            }
            placement="top"
          >
            {assignedFromUserFirstName.input.value}
          </Tooltip>
          Assigned to
        </Fragment>
      )}
      component={AutosuggestField}
      placeholder="-Select-"
      fullWidth
      labelOverlap
      renderSuggestionContent={suggestion => (
        `${suggestion['First Name']} ${suggestion['Last Name']}`
      )}
      renderInputContent={suggestion => (
        `${suggestion['First Name']} ${suggestion['Last Name']}`
      )}
      getSuggestionValue={suggestion => (
        `${suggestion['First Name']} ${suggestion['Last Name']}`
      )}
      onSuggestionSelected={(suggestion) => {
        assignedUserID.input.onChange(suggestion.ID);
        onFieldBlur({
          assignedUserName: `${suggestion['First Name']} ${suggestion['Last Name']}`,
          assignedUserID: suggestion.ID,
        });
        return `${suggestion['First Name']} ${suggestion['Last Name']}`;
      }}
      fetchSuggestions={({ value, limit, offset }) => (
        value.length > 0
          ? requestSearchUsers({
            filters: [
              {
                name: 'Role',
                operation: 'nin',
                val: ['Driver', 'System'],
              },
              {
                name: 'Active',
                operation: 'eq',
                val: 'true',
              },
              {
                name: 'Full Name',
                operation: 'startswith',
                val: value,
                case_sensitivity: false,
              },
            ],
            limit,
            offset,
          }).then(res => res.data)
          : requestSearchUsers({
            filters: [
              {
                name: 'Role',
                operation: 'nin',
                val: ['Driver', 'System'],
              },
              {
                name: 'Active',
                operation: 'eq',
                val: 'true',
              },
            ],
            limit,
            offset,
          }).then(res => res.data)
      )}
      onFocus={event => onFieldFocus({
        assignedUserName: event.target.value,
        assignedUserID: assignedUserID.input.value,
      })}
      validate={[validate.required]}
      disabled={disabled}
    />
  );
};

ProductClaimAssignedUserFields.propTypes = {
  name: PropTypes.string.isRequired,
  onFieldFocus: PropTypes.func.isRequired,
  onFieldBlur: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    tooltipAssignedBy: PropTypes.string.isRequired,
  }).isRequired,
};

ProductClaimAssignedUserFields.defaultProps = {
  disabled: false,
};

export default withStyles(styles)(ProductClaimAssignedUserFields);



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaim/ProductClaimAssignedUserFields.js